export default "__VITE_ASSET__8bfbfe8c__"